export class EmailListUrlParamsModel {
    customUrl?:string;
	customSaveUrl?:string;
    limit?: number;
    
    constructor() {
        this.customUrl = '';
		this.customSaveUrl = '';
        this.limit = 100;
    }
}